<template>
  <div class="jc-ip-container">
    <div class="jc-page-top">
      <div class="jc-page-header">
        <h1>
          <i class="jc-icon-my-circle-bold"></i>{{$t('ip.publicNetIp')}}
        </h1>
        <div class="jc-box-action">
          <a v-bind:href="Config.IP_SERVER_URL" target="_blank">{{$t('ip.helpDoc',[$t('ip.publicNetIp')])}}</a>
        </div>
      </div>
      <div class="jc-page-content">
        <!-- SearchListPane组件 -->
        <SearchListPane
          ref="searchPane"
          :search-configs="searchConfigs"
          :search-form-data="searchForm"
          @search="handleSearch"
          @reset="handleReset"
          :default-visible-count="3"
          :show-collapse-button="true"
        />
        <div class="el-container-table common-table-container">
          <!-- tableToolBar -->
          <div class="el-container-table-actionBar">
            <el-form class="el-box-table-search" :inline="true" @submit.native.prevent>
              <!-- <el-form-item>
                <el-input :placeholder="$t('placeholder.ipAddressSegment')" v-model="search" @keyup.enter.native="handleSearch" class="my-input"  clearable @clear="handleSearch">
                  <el-button slot="append" @click="handleSearch" icon="el-icon-search" class="search-icon"></el-button>
                </el-input>
              </el-form-item> -->
              <!-- tag -->
                <el-form-item class="set-icon">
                  <jcb-tag-filter :service-code="ServiceCodeConstant.CCS"
                                  :visible.sync="batchEditTagDialogVisible"
                                  :region-id="TagRegionID"
                                  @checkedTags="filterWithCheckedTags">
                  </jcb-tag-filter>
                </el-form-item>
              <el-form-item class="set-icon">
                <el-button icon="el-icon-setting" class="jc-button-icon" @click="setCustom()" :title="$t('merge.customList')"></el-button>
              </el-form-item>
              <el-form-item>
                <el-button icon="jc-icon-download" class="jc-button-icon" @click="exportList" :title="$t('speechcraft.exportResourceList')"></el-button>
              </el-form-item>
            </el-form>
            <el-form class="el-table-actionBar-item" :inline="true">
              <el-form-item>
                <el-button icon="jc-icon-refresh-line" class="el-button-icon" @click="updateList"></el-button>
              </el-form-item>
              <el-form-item>
                <!-- <el-radio-group v-model="selectedRegion" @change="selectRegion">
                    <el-radio-group-advance :max-shown-count="5" more-trigger="click" :more-label="$t('text.moreNode')">
                      <el-radio-button v-for="room in fliter_region"
                                    :key="room.idcId"
                                    :label="room.idcId"
                        >{{ room.region }}</el-radio-button
                      >
                    </el-radio-group-advance>
                  </el-radio-group> -->
                  <!-- <el-select v-model="selectedRegion" @change="selectRegion" :placeholder="$t('placeholder.choose')">
                    <el-option
                      :key="AllId"
                      :value="AllId"
                      :label="$t('ticket.complete')">
                    </el-option>
                    <el-option
                      v-for="room in fliter_region"
                      :key="room.idcId"
                      :value="room.idcId"
                      :label="room.region">
                    </el-option>
                  </el-select> -->
              </el-form-item>
            </el-form>
          </div>
          <div class="el-container-table">
            <el-table :data="ipAddressList" style="width: 100%" v-loading="refreshloading" :empty-text="tableEmptyTip" @filter-change="changeFilter" @selection-change="handleSelectionChange">
              <!-- 勾选 -->
              <el-table-column
                  type="selection"
                  width="55"
                  v-if="customInfo !== null">
                </el-table-column>
                <!-- ID -->
                <el-table-column prop="ipId"
                                 key="ipId"
                                 min-width="140"
                                 :label="$t('text.id')"
                                 v-if="getCustomInfoSelect('ipId')"
                                 fixed>
                  <template slot-scope="scope">
                    <span v-if=" scope.row.cidrAddr !== ''">{{scope.row.ipId}}</span>
                      <span v-else>--</span>
                  </template>
                </el-table-column>
                <!-- IP地址段 -->
              <el-table-column key="cidrAddr" min-width="200" prop="cidrAddr" :label="$t('ip.ipAddressSegment')" v-if="getCustomInfoSelect('cidrAddr')" fixed>
                <template slot-scope="scope">
                  <span v-if=" scope.row.cidrAddr !== ''">{{scope.row.cidrAddr}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <!-- 机房名称 -->
              <el-table-column prop="datacenterNameShow"
                                key="datacenterNameShow"
                                min-width="180"
                                :label="$t('cabinet.roomName')"
                                v-if="getCustomInfoSelect('datacenterNameShow')"
                                >
              </el-table-column>
              <!-- 机房名称 改为 托管区 -->
                <el-table-column prop="regionShow"
                                 key="regionShow"
                                 min-width="180"
                                 :label="$t('idcs.region')"
                                 v-if="getCustomInfoSelect('regionShow')">
                </el-table-column>
              <!-- IP地址数量 -->
              <el-table-column key="ipQuantity" min-width="100" prop="ipQuantity" :label="$t('ip.ipAmount')" v-if="getCustomInfoSelect('ipQuantity')">
                <template slot-scope="scope">
                  <div v-if=" scope.row.ipQuantity !== ''">
                    <span>{{ scope.row.ipQuantityWithUnit | maybeEmpty }}</span>
                  </div>
                </template>
              </el-table-column>
              <!-- IP类型 -->
              <el-table-column key="ipType" prop="ipType" min-width="100" :label="$t('ip.ipType')" v-if="getCustomInfoSelect('ipType')">
                <template slot-scope="scope">
                  <span v-if=" scope.row.ipType !== ''">{{scope.row.ipType}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <!-- 网络位地址 -->
              <!-- <el-table-column key="networkAddr" prop="networkAddr" min-width="120" :label="$t('ip.netWorkAddr')" v-if="customerInfo !== null && customerInfo['networkAddr'].selected" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if=" scope.row.networkAddr !== ''">{{scope.row.networkAddr}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column> -->
              <!-- 网关地址 -->
              <!-- <el-table-column key="gatewayAddr" prop="gatewayAddr" :label="$t('ip.gatewayAddress')" v-if="customerInfo !== null && customerInfo['gatewayAddr'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.gatewayAddr !== ''">{{scope.row.gatewayAddr}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column> -->
              <!-- 广播地址 -->
              <!-- <el-table-column key="broadcastAddr" prop="broadcastAddr" :label="$t('ip.bordcastAddr')" v-if="customerInfo !== null && customerInfo['broadcastAddr'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.broadcastAddr !== ''">{{scope.row.broadcastAddr}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column> -->
               <!-- 线路类型 -->
              <el-table-column key="lineTypeName" min-width="100" prop="lineTypeName" :label="$t('bandWidth.lineType')" v-if="getCustomInfoSelect('lineType')" >
                <template slot-scope="scope">
                 <span v-if="scope.row.lineTypeName">{{scope.row.lineTypeName | maybeEmpty}}</span>
                </template>
              </el-table-column>
              <!-- 计费信息 -->
              <el-table-column prop="cabinetOpenTime"
                                key="cabinetOpenTime"
                                min-width="170"
                                :label="$t('cabinet.billingInfo')"
                                v-if="getCustomInfoSelect('billingInfo')">
                <template slot-scope="scope">
                  <div>
                    <span>{{$t('ip.freeQuantity')}}: {{scope.row.freeQuantity}}</span><br/>
                    <span>{{$t('cabinet.billingTime')}}: {{scope.row.startTime | maybeEmpty}}</span><br/>
                    <span>{{$t('cabinet.expireTime')}}: {{scope.row.endTime | maybeEmpty}}</span>
                  </div>
                </template>
              </el-table-column>
              <!-- 状态 -->
              <!-- <el-table-column key="status" prop="status" :label="$t('text.status')" v-if="customerInfo !== null && customerInfo['status'].selected" :filter-multiple="false" :filters="filterList.status" :filter-method="filtersIpStatus" :filtered-value="filtersValue.status">
                <template slot-scope="scope">
                  <span :class="statusMap[scope.row.status]">{{filter_status[scope.row.status]}}</span>
                </template>
              </el-table-column> -->
              <!-- 标签 -->
              <el-table-column :label="$t('text.tags')"
                              key="tags"
                              v-if="getCustomInfoSelect('tags')"
                               min-width="150"
                              class-name="p-line-break">
                <template slot-scope="scope">
                  <p>{{scope.row.tagPairs | maybeEmpty}}</p>
                </template>
              </el-table-column>
                <!--操作-->
                <!-- <el-table-column key="operate"
                                    min-width="100"
                                 :label="$t('text.operate')">
                  <template slot-scope="scope">
                    <div style="display:flex">
                      <el-button type="text"
                                @click="clickOperateTag(scope.row)">
                        {{ $t('text.editTag') }}
                      </el-button>

                    </div>
                  </template>
                </el-table-column> -->
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar" v-if="ipAddressList.length">
      <el-tooltip class="item" effect="dark" :content="$t('text.pleaseSelectResource')" :disabled="!!multipleSelection.length" :visible-arrow="false" placement="top">
        <el-button type="primary" class="margin-top-ten"  :disabled="!multipleSelection.length" @click="batchEditTag">{{$t('text.editTag')}}</el-button>
      </el-tooltip>
      <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalItems">
      </el-pagination>
    </div>
    <custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type"></custom>
    <!--编辑标签-->
    <jcb-tag-edit :visible.sync="editTagDialogVisible"
                  :service-code="ServiceCodeConstant.CCS"
                  :region-id="TagRegionID"
                  :resource-ids="resourceId"
                  @complete="updateList">
    </jcb-tag-edit>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import custom from '../common/custom/Custom.vue';
import SearchListPane from '../common/search/SearchListPane.vue';
import { ServiceCodeConstant } from '@/common/Constants';
import { handleChangeAllSelectedValue, AllSelectOption, AllId, PlaceholderIdc } from '@/utils/common/index';
import searchOperate from '@/mixins/searchOperate';
import customInfoSelect from '@/mixins/customInfoSelect';

const type = 'ip';

export default {
  components: {
    custom,
    SearchListPane
  },
  mixins: [searchOperate, customInfoSelect],
  name: 'ip-address',
  data () {
    return {
      AllId,
      refreshloading: false,
      ipAddressList: [],
      statusMap: {
        'abnormal': 'jc-status jc-status--orange',
        'normal': 'jc-status jc-status--green'
      },
      filter_status: {
        'normal': this.$t('text.normal'),
        'abnormal': this.$t('text.abnormal'),
      },
      filtersValue: {
        ipLineType: [],
        status: [],
        ipType: []
      },
      search: '',
      currentPage: 1,
      totalItems: 0,
      pageSize: 20,
      pageSizes: [20, 50, 100],
      selectedRegion: AllId,
      fliter_region: [],
      regionMap: [],
      customVisible: false,
      type,
      initFlag: false,
      tableEmptyTip: this.$t('text.noSearch'),

      optionArr: [
        {
          label: this.$t('text.id'),
          value: 'ipId'
        },
        { label: this.$t('ip.ipAddressSegment'), value: 'cidrAddr' },
        {
          // 机房名称
          label: this.$t('cabinet.roomName'),
          value: 'datacenterNameShow'
        },
        {
          // 托管区
          label: this.$t('idcs.region'),
          value: 'regionShow'
        },
        { label: this.$t('ip.ipAmount'), value: 'ipQuantity' },
        { label: this.$t('ip.ipType'), value: 'ipType' },

        // { label: this.$t('ip.netWorkAddr'), value: 'networkAddr' },
        // { label: this.$t('ip.gatewayAddress'), value: 'gatewayAddr' },
        // { label: this.$t('ip.bordcastAddr'), value: 'broadcastAddr' },
        { label: this.$t('bandWidth.lineType'), value: 'lineType' },
        // 计费信息
        {
          label: this.$t('cabinet.billingInfo'),
          value: 'billingInfo'
        },
        // { label: this.$t('text.status'), value: 'status' },
        {
          // 标签
          label: this.$t('text.tags'),
          value: 'tags'
        }
        // {
        //   // 操作
        //   label: this.$t('text.operate'),
        //   value: 'operation'
        // }
      ],
      // SearchListPane配置
      searchConfigs: [
        {
          field: 'cidrAddr',
          type: 'input',
          label: this.$t('ip.ipAddressSegment'),
          placeholder: this.$t('placeholder.placeholderInput', [this.$t('ip.ipAddressSegment')])
        },
        {
          field: 'datacenterName',
          type: 'multiple-select',
          label: this.$t('cabinet.roomName'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('cabinet.roomName')]),
          options: []
        },
        {
          field: 'ipId',
          type: 'input',
          label: this.$t('text.id'),
          placeholder: this.$t('placeholder.placeholderInputMore', [this.$t('text.id')]),
        },
        {
          field: 'regionEn',
          type: 'multiple-select',
          label: this.$t('idcs.region'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('idcs.region')]),
          options: []
        },
        {
          field: 'ipType',
          type: 'select',
          label: this.$t('ip.ipType'),
          placeholder: this.$t('placeholder.placeholderSelect', [this.$t('ip.ipType')]),
          options: []
        },
        {
          field: 'ipLineType',
          type: 'multiple-select',
          label: this.$t('bandWidth.lineType'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('bandWidth.lineType')]),
          options: []
        }
      ],
      searchForm: {
        cidrAddr: '', // IP地址段
        datacenterName: [], // 机房名称
        ipId: '', // ID
        regionEn: [], // 托管区
        ipType: '', // IP类型
        ipLineType: [] // 线路类型
      },
      // 是否展开筛选
      isCollapsed: true,
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      // 批量编辑标签组件是否显示
      batchEditTagDialogVisible: true,
      resourceId: [],
      // 标签过滤后的资源ID
      filteredResourceIds: [],
      multipleSelection: [],
    };
  },
  created () {
    const query = this.$route.query;
    if (query.selectRoom !== undefined) {
      this.selectedRegion = query.selectRoom;
    }
    if (query.status !== undefined) {
      this.filtersValue.status.push(query.status);
    }
    if (query.ipType !== undefined) {
      this.filtersValue.ipType.push(query.ipType);
    }

    // 获取区域信息
    this.getRegion();

    // 自定义表头
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
  },
  mounted () { },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    needRequireResource () {
      return !!this.selectedRegion;
    },
    filterList () {
      return this.$store.state.filter.filterList;
    },
    customInfo () {
      return this.$store.state.customInfo[this.type];
    },
    filter_lineTypeName () { // 线路类型下拉选
      const tempArray = [];
      if (this.filterList.ipLineType) {
        this.filterList.ipLineType.forEach((element) => {
          tempArray.push({
            text: element.text,
            value: element.value
          });
        });
      }
      return tempArray;
    },
  },
  methods: {
    batchEditTag() {
      this.resourceId = [];
      this.multipleSelection.forEach((item) => {
        this.resourceId.push(item.ipId);
      });
      this.editTagDialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    clickOperateTag (data) {
      this.resourceId = [].concat([data.ipId]);
      this.editTagDialogVisible = true;
    },
    /**
     **@disc: 根据标签对实例进行过滤
     */
    filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
      console.log(filterTags, tagKeys, resourceIds);
      if (tagKeys.length !== 0) {
        this.filteredResourceIds = resourceIds;
      } else {
        this.filteredResourceIds = [];
      }
      this.updateList();
    },
    filterLineTypeName () {
      return true;
    },
    getRegion () {
      this.$api.getRegions({ all: 1, idcLine: this.GLOBAL.IDCLINE }).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.idcs.length > 0 && res.data.idcs[0] != null) {
            const data = res.data.idcs;
            this.regionFormat(data);
            // 更新SearchListPane选项数据
            this.initSearchOptions();
            if (this.$route.query.selectRoom !== undefined) {
              this.$nextTick(() => {
                this.selectedRegion = this.$route.query.selectRoom;
              })
            } else if (res.data.idcs) {
              // this.$nextTick(() => {
              //   this.selectedRegion = res.data.idcs[0].idc;
              // })
              this.selectedRegion = AllId;
            }
            this.$nextTick(() => {
              this.selectedRegion.length && this.selectRegion();
            })
          } else {
            this.fliter_region = [];
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },

    // 更新SearchListPane配置选项
    initSearchOptions() {
      // 更新机房名称选项
      const idcOptions = (this.fliter_region || []).map(region => ({
        value: region.datacenterNameParam,
        label: region.datacenterNameShow
      }));

      // 更新 托管区 选项
      const regionOptions = (this.fliter_region || []).map(region => ({
        value: region.regionEn,
        label: region.regionShow
      }));

      // 更新IP类型选项
      const ipTypeOptions = (this.filterList && this.filterList.ipType) ? [...this.filterList.ipType] : [];

      // 更新线路类型选项
      const lineTypeOptions = (this.filterList && this.filterList.lineType) ? [...this.filterList.lineType] : [];
      // 更新searchConfigs中的选项
      this.searchConfigs = this.searchConfigs.map(config => {
        if (config.field === 'datacenterName') {
          return { ...config, options: idcOptions };
        }
        if (config.field === 'regionEn') {
          return { ...config, options: regionOptions };
        }
        if (config.field === 'ipType') {
          return { ...config, options: ipTypeOptions };
        }
        if (config.field === 'ipLineType') {
          return { ...config, options: lineTypeOptions };
        }
        return config;
      });
    },

    // 获取自定义信息
    getCustomInfo () {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((res) => {
        if (res.errno === 10000 && res.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: res.data.customInfo, type: this.type });
        }
      });
    },
    // 获取列表
    getIpAddress (params) {
      // if (params.idc) {
      //   this.selectedRegion = params.idc;
      // }
      if (!this.needRequireResource) {
        return;
      }
      const dataParams = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        // idc: this.selectedRegion
      };
      let tempParams = params === undefined ? dataParams : params;
      // 是否通过标签进行筛选
      if (this.filteredResourceIds.length) {
        tempParams.ipId = this.filteredResourceIds.join(' ');
      }
      // 选择下拉筛选的“全部”all
      // tempParams = {...tempParams, ...handleChangeAllSelectedValue(this.selectedRegion)}
      this.refreshloading = true;
      this.$api.getNetworksList(tempParams).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.ips.length > 0 && res.data.ips[0] != null) {
            const data = res.data.ips;
            this.totalItems = res.data.totalCount;
            this.refreshloading = false;
            this.ipAddressList = cloneDeep(data);
            this.ipAddressList.forEach((item) => {
              item.tagPairs = '';
              if (item.tags !== undefined && item.tags.length > 0) {
                item.tags.forEach((tag) => {
                  item.tagPairs += `${tag.key}:${tag.value},`;
                });
                item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
              }
            });
          } else {
            this.refreshloading = false;
            this.ipAddressList = [];
            this.totalItems = 0;
          }
        } else {
          this.refreshloading = false;
          this.$message.error(res.errmsg);
        }
        this.initFlag = false;
      }, (error) => {
        this.refreshloading = false;
        this.ipAddressList = [];
        this.totalItems = 0;
        this.$message.error(error.message);
      }).finally(() => {
        this.refreshloading = false;
        // this.filteredResourceIds = [];
      });
    },

    regionFormat (data) {
      this.fliter_region = [];
      for (let i = 0; i < data.length; i++) {
        this.fliter_region.push({
          // idcId: data[i].idc,
          // idcNo: data[i].idcNo,
          // region: data[i].idcName,
          regionEn: data[i].regionEn,
          regionShow: data[i].regionShow,
          datacenterNameShow: data[i].datacenterNameShow,
          datacenterNameParam: data[i].datacenterNameParam
        });
      }
      // 插入原始“全部”选项
      // this.fliter_region.unshift(AllSelectOption(this, 'idcId', 'region'))
    },

    updateList (type) {
      if (!this.needRequireResource) {
        return;
      }
      // 切换区域不保留条件
      this.tableEmptyTip = this.$t('text.noSearch');
      if (type == 'refresh') {
        this.refreshloading = true;
        this.search = '';
        this.initFlag = true;
        this.currentPage = 1;
        this.tableEmptyTip = this.$t('text.noSearch');
      }
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        // idc: this.selectedRegion
      };

      if (this.selectedRegion && this.selectedRegion !== AllId && !this.searchForm.regionEn.length && !this.searchForm.datacenterName.length) {
        params.regionEn = this.selectedRegion;
      }

      // 处理搜索表单数据
      if (this.searchForm) {
        // 使用for...in循环处理搜索参数
        for (const key in this.searchForm) {
          const value = this.searchForm[key];
          if (Array.isArray(value) && value.length > 0) {
            // 处理数组类型参数（多选下拉框）
            params[key] = value.join(',');
          } else if (typeof value === 'string' && value.trim() !== '') {
            // 处理字符串类型参数（输入框）
            params[key] = value.trim();
          }
        }

        // 特殊处理：IP地址段搜索时显示搜索提示
        if (this.searchForm.cidrAddr && this.searchForm.cidrAddr.trim() !== '') {
          this.tableEmptyTip = this.$t('text.hasSearch');
        }
      }

      // 保留原有的筛选逻辑
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          params[key] = this.filtersValue[key][0];
        }
      });
      this.getIpAddress(params);
    },

    // 导出列表
    exportList () {
      if (!this.needRequireResource) {
        return;
      }
      let url = `/ccs-api/api/resource/exportIps?cidrAddr=${this.search}&all=1`;
      // 全选，导出列表参数拼接 ignoreIdc = 1
      // if (this.selectedRegion === AllId) {
      //   url = `/ccs-api/api/resource/exportIps?ignoreIdc=1&idc=${PlaceholderIdc}&cidrAddr=${this.search}&all=1`;
      // }
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          url += `&${key}=${this.filtersValue[key][0]}`;
        }
      });
      if (this.selectedRegion && this.selectedRegion !== AllId && !this.searchForm.regionEn.length && !this.searchForm.datacenterName.length) {
        url += `&regionEn=${this.selectedRegion}`;
      }
      // 增加遍历搜索表单参数
      if (this.searchForm) {
        for (const key in this.searchForm) {
          const val = this.searchForm[key];
          if (val !== '' && val !== null && val !== undefined) {
            if (Array.isArray(val) && val.length === 0) {
              continue;
            }
            url += `&${key}=${val}`;
          }
        }
      }
      // 拼接 针对 filteredResourceIds 标签 过滤的入参
      if (this.filteredResourceIds.length) {
        url += `&ipId=${this.filteredResourceIds.join(' ')}`;
      }
      console.log(url);

      window.open(url, '_self');
    },

    // 自定义
    setCustom () {
      this.customVisible = true;
    },

    handleSizeChange (val) {
      this.pageSize = val;
      this.updateList();
    },

    handleCurrentChange (val) {
      this.currentPage = val;
      if (!this.initFlag) {
        this.updateList();
      }
    },

    filterIpAddressType (value, row) {
      return row.status === value;
    },

    selectRegion () {
      if (this.fliter_region.length > 0) {
        this.updateList('refresh');
      }
    },

    transformParams () {
      let param = this.$route.query.ipStatus;
      if (param === 'normal') {
        param = 1;
      } else if (param === 'abnormal') {
        param = 2;
      } else {
        param = '';
      }
      return param;
    },

    filtersIpStatus (value, row) {
      return true;
    },

    // 根据状态搜索
    changeFilter (filter) {
      this.currentPage = 1;
      this.updateList('refresh');
    }
  }
};
</script>
<style lang="sass">
  @import "./IpAddress.scss"
</style>



// WEBPACK FOOTER //
// src/components/ipAddress/IpAddress.vue